var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotorcycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.5,8.6c0.5-0.1,1-0.6,1-1.1c0-0.7-0.5-1.2-1.2-1.2c-0.2,0-0.4,0.1-0.7,0.2L17.5,8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.3,14c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S4.7,14,4.3,14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.7,11.6c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3S21.5,11.6,19.7,11.6z M19.7,17.2 c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C21.9,16.2,20.9,17.2,19.7,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.3,11.6C2.5,11.6,1,13.1,1,15s1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3S6.2,11.6,4.3,11.6z M4.3,17.2 c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2s2.2,1,2.2,2.2C6.5,16.2,5.6,17.2,4.3,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.7,14.1c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9S20.1,14.1,19.7,14.1z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,15.4c-0.2,0.1-0.5,0-0.6-0.3l-2.9-7.4l-0.2-0.5c0,0-0.4-0.8-1.9-0.6c-0.2,0-0.4-0.1-0.5-0.4l0,0 c0-0.3,0.1-0.5,0.4-0.5c2.2-0.3,2.8,1,2.9,1.2l0,0l0.2,0.5l2.8,7.3C20.2,15,20.1,15.3,19.8,15.4L19.8,15.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8,14.3H8.9c0-1-1.5-2.3-2.7-3.3c-0.9-0.7-1.7-1.2-1.7-1.2L4,9.6L3.1,9.4C2.4,9.3,1.9,8.7,1.9,8 c0,0,1.4,0.1,2.9,0.2c0,0,0,0,0.1,0C6.4,8.3,8,8.4,8.3,8.4c0.6,0,1.8,0.7,1.8,0.7C11,8.5,12,8.1,12.8,8c2.5-0.3,4.6,1.2,4.6,1.2 S17.7,12.5,13.8,14.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4,12.1c-0.1,0-3.1,1.8-4.1,2.5c-0.2,0.1-0.3,0.3-0.2,0.5l0,0c0.1,0.2,0.3,0.4,0.5,0.3L9,14.3l0.4-2.2 L8.4,12.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,9.2c0,0-1.8,1.6-3.8,1.8c-0.9-0.7-1.7-1.2-1.7-1.2L3.1,9.4C2.4,9.3,1.9,8.7,1.9,8l0,0 c0,0,5.8,0.5,6.4,0.5S10.1,9.2,10.1,9.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,9.6c0,0,2.2-1.1,4.3,1.3c0,0-2.6-1.3-4,0.1L17.8,9.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M12.8,8.1c-0.2,1-1.3,4.2-6.6,2.9c-0.9-0.7-1.7-1.2-1.7-1.2L4,9.6c-0.1-0.5,0.3-1,0.8-1.4c0,0,0,0,0.1,0 C6.5,8.4,8,8.5,8.3,8.5c0.6,0,1.8,0.7,1.8,0.7C11,8.5,12,8.2,12.8,8.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.38040f4064b55f53697f54c4bb863975.svg";
export { ForwardRef as ReactComponent };